import { render } from "./AppSettings.vue?vue&type=template&id=e684b846"
import script from "./AppSettings.vue?vue&type=script&lang=js"
export * from "./AppSettings.vue?vue&type=script&lang=js"

import "./AppSettings.vue?vue&type=style&index=0&id=e684b846&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__